import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import {INIT_STATE_NAME, InitState} from "./init";
import {Serializer, Serializers} from '../../interfaces/serializer';
import {Space} from '../../interfaces/space';
import {Site} from '../../interfaces/site';
import {User} from '../../interfaces/user';

export const selectInitState: MemoizedSelector<object, InitState> = createFeatureSelector<InitState>(INIT_STATE_NAME);

export const selectIsLogged: MemoizedSelector<object, boolean> = createSelector(
  selectInitState,
  (state: InitState) => state.logged
);

export const selectInitIsLoaded: MemoizedSelector<object, boolean> = createSelector(
  selectInitState,
  (state: InitState) => state.loaded
);

export const selectLogInErrors: MemoizedSelector<object, Array<string>> = createSelector(
  selectInitState,
  (state: InitState) => state.errors
);

export const selectLogInLoading: MemoizedSelector<object, boolean> = createSelector(
  selectInitState,
  (state: InitState) => state.loading
);

export const selectSpace: MemoizedSelector<object, Serializer<Space>> = createSelector(
  selectInitState,
  (state: InitState) => state.space
);

export const selectSpaceName: MemoizedSelector<object, string> = createSelector(
  selectInitState,
  (state: InitState) => state.space.attributes.name
);

export const selectSites: MemoizedSelector<object, Serializers<Site>> = createSelector(
  selectInitState,
  (state: InitState) => state.sites
);

export const selectSitesLoading: MemoizedSelector<object, boolean> = createSelector(
  selectInitState,
  (state: InitState) => state.loading
);

export const selectSite: MemoizedSelector<object, Serializer<Site>> = createSelector(
  selectInitState,
  (state: InitState) => state.site
);

export const selectSiteUserRole: MemoizedSelector<object, string> = createSelector(
  selectInitState,
  (state: InitState) => state.site.attributes.user_role
);

export const selectSiteMatchingsStatus: MemoizedSelector<object, any> = createSelector(
  selectInitState,
  (state: InitState) => state.site?.attributes.statuses.matchings
);

export const selectSiteID: MemoizedSelector<object, number> = createSelector(
  selectInitState,
  (state: InitState) => state.site?.id
);

export const selectUser: MemoizedSelector<object, Serializer<User>> = createSelector(
  selectInitState,
  (state: InitState) => state.user
);

export const selectUserSpaceRole: MemoizedSelector<object, string> = createSelector(
  selectInitState,
  (state: InitState) => state.user.attributes.space_role
);

export const selectIsSpaceAdmin: MemoizedSelector<object, boolean> = createSelector(
  selectInitState,
  (state: InitState) => state.isSpaceAdmin
);

export const selectIsDatasetAdmin: MemoizedSelector<object, boolean> = createSelector(
  selectInitState,
  (state: InitState) => state.isDatasetAdmin
);

export const selectIsAdmin: MemoizedSelector<object, boolean> = createSelector(
  selectInitState,
  (state: InitState) => state.isAdmin
);

export const selectIsSuperAdmin: MemoizedSelector<object, boolean> = createSelector(
  selectInitState,
  (state: InitState) => state.isSuperAdmin
);

export const selectCode: MemoizedSelector<object, number> = createSelector(
  selectInitState,
  (state: InitState) => state.code
);

export const selectPlanIsOK: MemoizedSelector<object, boolean> = createSelector(
  selectInitState,
  (state: InitState) => state.code === 200
);

export const selectIsAdloopTeam: MemoizedSelector<object, boolean> = createSelector(
  selectInitState,
  (state: InitState) => state.user.attributes.sa
);

export const selectCanModify: (userID: number | string) => MemoizedSelector<object, boolean> = (userID: number | string) => createSelector(
  selectInitState,
  (state: InitState) => state.isDatasetAdmin || state.user.id == userID
);
